import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectReceiptTransaction } from "../../../../redux/slices/receiptsSlice";
import { selectErrors } from "../../../../redux/slices/appSettingsSlice";
import RecurringSummaryCancel from "./RecurringSummaryCancel";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryCancel = ({ control }) => {
    const { recurring = {} } = useSelector(selectReceiptTransaction);
    const { status = "" } = recurring;

    const errors = useSelector(selectErrors);
    const hasError = errors?.length > 0;

    const [displayModal, setDisplayModal] = useState(false);

    // Remove the modal from the UI to ensure that the donor
    // can see the error message that we are displaying which is
    // located at the top of the donation form.
    useEffect(() => {
        if (hasError) {
            setDisplayModal(false);
        }
    }, [hasError]);

    // Note: Cancelled recurring transactions have a status of "deleted"
    // rather than "cancelled" as one would expect
    const displayCancelWidget = status !== "deleted";

    const recurringSummaryCancelProps = {
        control,
        displayCancelWidget,
        displayModal,
        setDisplayModal,
    };

    return <RecurringSummaryCancel {...recurringSummaryCancelProps} />;
};

export default ConnectedRecurringSummaryCancel;
